import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { create_user, update_user } from '../api/api.js';
import { toast } from 'react-toastify';

const UserModal = forwardRef(({ isOpen, onClose, userdata }, ref) => {
  const [id, setId] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [deviceCode, setDeviceCode] = useState('');
  const [ruolo, setRuolo] = useState('utente');
  const [error, setError] = useState('');

  // Reset method
  useImperativeHandle(ref, () => ({
    reset: () => {
      setFirstName('');
      setLastName('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setRuolo('Base');
      setError('');
    },
    setup: (the_user) => {
      setId(the_user?.id);
      setFirstName(the_user?.first_name);
      setLastName(the_user?.last_name);
      setEmail(the_user?.email);
      setPassword('');
      setConfirmPassword('');
      setRuolo(the_user?.role);
      setError('');
    }
  }));


  const handleUpdate = async () => {
    // Validazione semplice

    if (password !== confirmPassword) {
      setError('Le password non coincidono.');
      return;
    }

    try {

      var data = {}
      data.id = id;
      data.first_name = firstName;
      data.last_name = lastName;
      data.email = email;
      data.password = password;
      data.password_confirmation = confirmPassword;
      data.role = ruolo;
      await update_user(data.id, data);

      // Se tutto ok
      setError('');
      onClose();
    } catch (err) {
      setError('Errore durante la richiesta. Riprova.');
    }
  };





  const handleNext = async () => {
    // Validazione semplice
    if (
      !firstName.trim() ||
      !lastName.trim() ||
      !email.trim() ||
      !password.trim() ||
      !confirmPassword.trim()
    ) {
      setError('Tutti i campi devono essere compilati.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Le password non coincidono.');
      return;
    }

    try {

      var data = {}
      data.first_name = firstName;
      data.last_name = lastName;
      data.email = email;
      data.password = password;
      data.password_confirmation = confirmPassword;
      data.role = ruolo;

      await create_user(data);
      toast.success("Salvataggio avvenuto con successo");

      // Se tutto ok
      setError('');
      onClose();
    } catch (err) {
      setError('Errore durante la richiesta. Riprova.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container-big">
        <div className="modal-header">
          <h2 className="modal-title-document">{!!userdata ? "Modifica Utente": "Crea nuovo utente"}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content-large">
          <div className="modal-body">
            <div className="modal-update-subtitle">Compila i campi dell'utente</div>

            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Nome</label>

            <input
              type="text"
              placeholder="Nome"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="field-input"
            />

            </div>
            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Cognome</label>

            <input
              type="text"
              placeholder="Cognome"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="field-input"
            />

            </div>
            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Email</label>

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
            />

            </div>
            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Password</label>

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
            />

            </div>
            <div style={{marginBottom:"12px"}}>

            <label className="field-label">Conferma Password</label>

            <input
              type="password"
              placeholder="Conferma Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="field-input"
            />

            </div>
            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Ruolo</label>


            <select
              value={ruolo}
              onChange={(e) => setRuolo(e.target.value)}
              className="field-input"
            >
              <option value="Base">Utente</option>
              <option value="Admin">Amministratore</option>
            </select>


            </div>


            {error && <div className="modal-error">{error}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button className="footer-btn btn-secondary" onClick={onClose}>Indietro</button>
          <button className="footer-btn btn-primary longbutton" onClick={!!userdata ? handleUpdate : handleNext}>
            {!!userdata ? "Modifica Utente": "Crea Utente"}
          </button>
        </div>
      </div>
    </div>
  );
});

export default UserModal;
